<script setup lang="ts">
import { ref } from "vue";
import { Router, useRouter } from "vue-router";
import DarkModeToggle from '@/components/layout/DarkModeToggle.vue';
import Search from '@/components/search/SearchField.vue';
import UserHeaderMenu from '@/components/navigation/UserHeaderMenu.vue';
import SupportHeaderMenu from '@/components/navigation/SupportHeaderMenu.vue';
import routeManager from "@/router/route-manager";
import { useMenuPermissions } from "@/composables/menu-permissions";
import SocialHeaderMenu from "@/components/navigation/SocialHeaderMenu.vue";

const { showMainSearch } = useMenuPermissions();

const router: Router = useRouter();

const showMobileMenu = ref( false );
router.beforeEach( () => {
  showMobileMenu.value = false;
} );

async function navigateToSecurityDetails ( ticker: string ) {
  await router.push( routeManager.buildSecurityPath( ticker ) );
}

async function navigateToSectorDetails ( symbol: string ) {
  await router.push( routeManager.sectorDetailsRouteBySymbol( symbol ) );
}
</script>

<template>
  <div class="flex justify-between items-center pt-1 pb-1">

    <router-link :to="routeManager.homePath()" class="tmi-logo flex-shrink-0 w-32 h-9 mr-4 ml-2 hidden lg:block" />

    <div class="flex w-full max-w-[400px]">
      <Search v-if=" showMainSearch "
        class="flex w-full max-w-[300px]"
        :stock-click-handler="navigateToSecurityDetails"
        :etf-click-handler="navigateToSecurityDetails"
        :sector-click-handler="navigateToSectorDetails" />
     </div>

    <div class="flex items-center">
      <SocialHeaderMenu />
      <SupportHeaderMenu />
      <UserHeaderMenu />
      <DarkModeToggle />
    </div>

  </div>

</template>